import styles from './InfoTooltip.module.css'
import { Tooltip } from '@fluentui/react-components'
import { InfoRegular } from '@fluentui/react-icons'
import { useEffect } from 'react'

interface InfoTooltipProps {
  content?: JSX.Element
}

export const InfoTooltip = ({ content }: InfoTooltipProps) => {
  // Apply global styles to ensure tooltip displays properly
  useEffect(() => {
    // Create a style element to add global CSS
    const styleEl = document.createElement('style')
    styleEl.textContent = `
      .fui-Tooltip, .ms-Tooltip, .ms-Callout, .ms-Layer, .fui-Popup {
        border-radius: 0 !important;
        overflow: visible !important;
      }
      
      .fui-Tooltip *, .ms-Tooltip *, .ms-Callout *, .ms-Layer *, .fui-Popup * {
        border-radius: 0 !important;
      }
      
      .fui-Tooltip-content, .ms-Tooltip-content, .ms-Callout-main {
        border-radius: 0 !important;
      }
      
      .fui-Tooltip-arrow, .ms-Callout-beak {
        display: none !important;
      }
    `
    document.head.appendChild(styleEl)

    return () => {
      document.head.removeChild(styleEl)
    }
  }, [])

  if (content) {
    return (
      <div className={styles.infoTooltipWrapper}>
        <Tooltip content={content} relationship="label">
          <InfoRegular
            style={{
              display: 'flex',
              justifyContent: 'center',
              cursor: 'default',
            }}
          />
        </Tooltip>
      </div>
    )
  }

  return null
}
